import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyTopBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#DC2626] text-white py-2 px-4 shadow-md" data-id="element-136">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-sm md:text-base font-medium" data-id="element-137">
        <span data-id="element-138">Esta oferta termina pronto:</span>
        <CountdownTimer className="text-yellow-200" data-id="element-139" />
      </div>
    </div>;
}